import { useMemo } from 'react';
import { INCIDENT_V2_MERGE_CARDS } from '@elementary/common-ui/constants/queryKeys';
import useGraphqlPagedQuery from '@elementary/common-ui/hooks/useGraphqlPagedQuery';
import { getIncidentsForMergeQuery } from '../api';
import type { IncidentMergeCard, IncidentsForMergeResponse } from '../types';

const selectPage = (data: IncidentsForMergeResponse) => data.incidentsV2Paged;

const useIncidentV2MergeCards = (incidentIds: string[]) => {
  const queryResult = useGraphqlPagedQuery<
    IncidentMergeCard,
    IncidentsForMergeResponse
  >({
    queryKey: [INCIDENT_V2_MERGE_CARDS, incidentIds],
    query: getIncidentsForMergeQuery,
    variables: {
      filters: { incidentIds },
      limit: incidentIds.length,
    },
    enabled: incidentIds.length > 0,
    select: selectPage,
  });

  const data = useMemo(() => {
    const byId = new Map(
      queryResult.data.map((incident) => [incident.id, incident]),
    );
    return incidentIds
      .map((id) => byId.get(id))
      .filter((incident) => !!incident);
  }, [queryResult.data, incidentIds]);

  return { ...queryResult, data };
};

export default useIncidentV2MergeCards;
